import { createFilledIcon } from '@ps/ds/icons/helpers/createFilledIcon'

export const Hourglass = createFilledIcon('Hourglass', [
  [
    'path',
    {
      d: 'M19 1.125C19.4832 1.125 19.875 1.51675 19.875 2C19.875 2.48325 19.4832 2.875 19 2.875H17.875V6.17188L17.8613 6.45605C17.7959 7.11418 17.504 7.73239 17.0322 8.2041L13.2373 11.999L17.0332 15.7949C17.5723 16.3339 17.8748 17.0658 17.875 17.8281V21.125H19C19.4832 21.125 19.875 21.5168 19.875 22C19.875 22.4832 19.4832 22.875 19 22.875H5C4.51675 22.875 4.125 22.4832 4.125 22C4.125 21.5168 4.51675 21.125 5 21.125H6.125V17.8281C6.12516 17.0657 6.42857 16.334 6.96777 15.7949L10.7617 12L6.9668 8.20508C6.49501 7.73336 6.20408 7.11418 6.13867 6.45605L6.125 6.17188V2.875H5C4.51675 2.875 4.125 2.48325 4.125 2C4.125 1.51675 4.51675 1.125 5 1.125H19ZM8.20508 17.0332C7.9941 17.2441 7.87508 17.5298 7.875 17.8281V21.125H16.125V17.8281C16.1249 17.5298 16.0059 17.2441 15.7949 17.0332L12 13.2383L8.20508 17.0332ZM7.875 2.875V6.17188L7.88086 6.2832C7.90286 6.50386 7.9893 6.71326 8.12988 6.88477L8.20508 6.9668L12 10.7617L15.7949 6.9668C15.9795 6.78229 16.0935 6.54063 16.1191 6.2832L16.125 6.17188V2.875H7.875Z',
      stroke: 'none',
      key: 'Hourglass-0',
    },
  ],
  [
    'path',
    {
      d: 'M14 4H10C9.44772 4 9 4.44772 9 5V5.58579C9 5.851 9.10536 6.10536 9.29289 6.29289L11.2364 8.23641C11.6483 8.64831 12.3237 8.62237 12.7028 8.1801L14.7593 5.78087C14.9146 5.59962 15 5.36879 15 5.13008V5C15 4.44772 14.5523 4 14 4Z',
      stroke: 'none',
      key: 'Hourglass-1',
    },
  ],
  [
    'path',
    {
      d: 'M14 20H10C9.44772 20 9 19.5523 9 19V18.4142C9 18.149 9.10536 17.8946 9.29289 17.7071L11.2364 15.7636C11.6483 15.3517 12.3237 15.3776 12.7028 15.8199L14.7593 18.2191C14.9146 18.4004 15 18.6312 15 18.8699V19C15 19.5523 14.5523 20 14 20Z',
      stroke: 'none',
      key: 'Hourglass-2',
    },
  ],
])

Hourglass.displayName = 'Hourglass'
